import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExportHelperService {

  constructor(private http: HttpClient) {}

  exportPaginatedChunks<T>(
    apiFn: (params: any) => Observable<any>,
    params: any,
    chunkSize: number,
    callback: (allData: T[]) => void
  ): void {
    let page = 0;
    let allData: T[] = [];
  
    const fetchNext = () => {
      const paginatedParams = {
        ...params,
        pageNumber: page,
        pageSize: chunkSize
      };
  
      apiFn(paginatedParams).subscribe({
        next: (data) => {
          data?.responseObject?.content.forEach((el:any)=>{
            if(el && el?.invoiceLineItems || el && el?.invoiceLineItems?.length > 0 ){
              el.venderInvoiceNumber = el?.invoiceLineItems
            } 
             if(el?.approvalUser || el?.approvalUser?.length > 0 ){
              el.currentApprovalUser = el?.approvalUser
              el.allApprovalsUser = el?.approvalUser
            }  
          })
          const content = data?.responseObject?.content || [];
          allData = allData.concat(content);
          
          const totalElements = data?.responseObject?.totalElements || 0;
          const totalPages = Math.ceil(totalElements / chunkSize);
  
          if (page + 1 < totalPages) {
            page++;
            fetchNext();
          } else {
            callback(allData);
          }
        },
        error: () => callback(allData)
      });
    };
  
    fetchNext();
  }
  
  
}
